import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { MerakiAdminAuditComponent } from '@app/features/merakis/modules/meraki-admin-audit/pages/meraki-admin-audit.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        MerakiAdminAuditComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class MerakiAdminAuditModule {}